(function () {
    'use strict';

    angular
        .module('app')
        .controller('WorkflowHistoryCtrl', WorkflowHistoryCtrl);

    WorkflowHistoryCtrl.$inject = [
        '$routeParams',
        'ChilliUserProfileService'];

    function WorkflowHistoryCtrl(
        $routeParams,
        ChilliUserProfileService) {
        /* jshint validthis:true */
        var vm = this;
        vm.loading = true;
        vm.permissionDenied = false;
        vm.workflowId = $routeParams.id;

        activate();

        function activate() {
            ChilliUserProfileService.verifyUserIsAdministrator({
                onUserIsNotAdmin: function () {
                    vm.permissionDenied = true;
                },
                onError: function (response) { DialogService.error('Error loading User profile', response); },
                onFinally: function () { vm.loading = false; }
            });
        }
    }
})();
